import React from 'react';
import Home from "./pages/home";
import { Router } from "react-router-dom";
import "assets/scss/base.scss?v=1.8.0";

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
